var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BaseModalForm', {
    attrs: {
      "editable": "",
      "headline": _vm.headline,
      "modalType": _vm.modalType,
      "loading": _vm.isLoading || _vm.isSaving
    },
    on: {
      "submit": _vm.handleSubmit,
      "close": function close($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm.isLoading ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }) : _vm.loadError ? _c('v-alert', {
    attrs: {
      "type": "error",
      "outlined": "",
      "data-cy": "cost-load-error"
    }
  }, [_vm._v(_vm._s(_vm.loadError))]) : _c('v-form', {
    ref: "connectForm",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "data-cy": "name",
      "readonly": _vm.readonly,
      "label": "Kostnadstype",
      "rules": [function (v) {
        return !!v || 'Fyll inn navn på kostnaden.';
      }],
      "required": ""
    },
    model: {
      value: _vm.costModel.name,
      callback: function callback($$v) {
        _vm.$set(_vm.costModel, "name", $$v);
      },
      expression: "costModel.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "data-cy": "price",
      "type": "number",
      "readonly": _vm.readonly,
      "label": "Sats",
      "suffix": " kr",
      "rules": _vm.validateNonNegativeNumber,
      "required": ""
    },
    model: {
      value: _vm.costModel.price,
      callback: function callback($$v) {
        _vm.$set(_vm.costModel, "price", _vm._n($$v));
      },
      expression: "costModel.price"
    }
  })], 1), _vm.costName == _vm.ExpenseType.SalaryRoute ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.costTypesSalaryCost,
      "readonly": _vm.readonly,
      "disabled": _vm.isEditing,
      "label": "Kategori",
      "item-text": function itemText(item) {
        return "".concat(item.id, " - ").concat(item.name);
      },
      "item-value": "id",
      "rules": [function (v) {
        return !!v || 'Velg kategori';
      }]
    },
    model: {
      value: _vm.costTypeId,
      callback: function callback($$v) {
        _vm.costTypeId = $$v;
      },
      expression: "costTypeId"
    }
  }), _c('v-text-field', {
    attrs: {
      "data-cy": "deductionCode",
      "readonly": _vm.readonly,
      "label": "Trekkode"
    },
    model: {
      value: _vm.costModel.deductionCode,
      callback: function callback($$v) {
        _vm.$set(_vm.costModel, "deductionCode", _vm._n($$v));
      },
      expression: "costModel.deductionCode"
    }
  }), _c('v-text-field', {
    attrs: {
      "data-cy": "payType",
      "readonly": _vm.readonly,
      "label": "Lønnsart",
      "rules": [function (v) {
        return !!v || 'Feltet er påkrevd.';
      }, function (v) {
        return /^\d{4}$/.test(v) || 'Lønnsart skal bestå av 4 siffer. ';
      }],
      "required": ""
    },
    model: {
      value: _vm.costModel.payType,
      callback: function callback($$v) {
        _vm.$set(_vm.costModel, "payType", _vm._n($$v));
      },
      expression: "costModel.payType"
    }
  })], 1) : _vm._e(), _vm.costName == _vm.ExpenseType.ExpenseRoute ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.costTypesExpenses,
      "readonly": _vm.readonly,
      "disabled": _vm.isEditing,
      "label": "Kategori",
      "item-text": function itemText(item) {
        return "".concat(item.id, " - ").concat(item.name);
      },
      "item-value": "id",
      "rules": [function (v) {
        return !!v || 'Velg kategori';
      }]
    },
    model: {
      value: _vm.costTypeId,
      callback: function callback($$v) {
        _vm.costTypeId = $$v;
      },
      expression: "costTypeId"
    }
  }), _vm.costTypeId === 512 ? _c('v-autocomplete', {
    attrs: {
      "items": _vm.travelAndExpenseTypes,
      "readonly": _vm.readonly,
      "rules": [function (v) {
        return !!v || 'Velg utgiftstype';
      }],
      "label": "Utgiftstype"
    },
    model: {
      value: _vm.costModel.travelAndExpenseType,
      callback: function callback($$v) {
        _vm.$set(_vm.costModel, "travelAndExpenseType", $$v);
      },
      expression: "costModel.travelAndExpenseType"
    }
  }) : _vm._e(), _c('v-autocomplete', {
    attrs: {
      "items": _vm.teachingMethodsList,
      "readonly": _vm.readonly,
      "label": "Undervisningsform"
    },
    model: {
      value: _vm.costModel.teachingMethod,
      callback: function callback($$v) {
        _vm.$set(_vm.costModel, "teachingMethod", $$v);
      },
      expression: "costModel.teachingMethod"
    }
  }), _c('v-text-field', {
    attrs: {
      "readonly": _vm.readonly,
      "label": "Artikkelnummer",
      "rules": [function (v) {
        return !!v || 'Feltet er påkrevd';
      }],
      "hint": "Artikkelnummeret finnes i Visma ePlus og styres derfra.",
      "persistent-hint": ""
    },
    model: {
      value: _vm.costModel.articleNo,
      callback: function callback($$v) {
        _vm.$set(_vm.costModel, "articleNo", $$v);
      },
      expression: "costModel.articleNo"
    }
  }), _c('v-textarea', {
    attrs: {
      "readonly": _vm.readonly,
      "label": "Beskrivelse",
      "rules": [function (v) {
        return !!v || 'Fyll inn beskrivelse på kostnaden.';
      }]
    },
    model: {
      value: _vm.costModel.description,
      callback: function callback($$v) {
        _vm.$set(_vm.costModel, "description", $$v);
      },
      expression: "costModel.description"
    }
  }), _c('v-divider', {
    staticClass: "my-4"
  }), _c('div', {
    staticClass: "subtitle-1 font-weight-medium"
  }, [_vm._v("Økonomi Innstillinger")]), _c('p', {
    staticClass: "caption grey--text text--darken-1 mb-1"
  }, [_vm._v(" Innstillingene administreres i Visma ePlus via artikkelnummeret og må derfor være like her for at overføringen skal fungere. ")]), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.costSettingControls, function (setting) {
    return _c('v-col', {
      key: setting.key,
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c('div', {
      staticClass: "d-flex align-center"
    }, [_c('v-switch', {
      staticClass: "mt-0",
      attrs: {
        "data-cy": setting.key,
        "label": setting.label,
        "disabled": _vm.readonly,
        "hide-details": "",
        "inset": ""
      },
      model: {
        value: _vm.costModel.economySystemSettings[setting.key],
        callback: function callback($$v) {
          _vm.$set(_vm.costModel.economySystemSettings, setting.key, $$v);
        },
        expression: "costModel.economySystemSettings[setting.key]"
      }
    })], 1)]);
  }), 1)], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-switch', {
    attrs: {
      "data-cy": "isActive",
      "readonly": _vm.readonly,
      "value": false,
      "inset": "",
      "rules": [function (v) {
        return /(?:true|false)/.test(v) || 'Velg emnetype.';
      }],
      "label": _vm.costModel.isActive ? 'Er aktiv' : 'Inaktiv'
    },
    model: {
      value: _vm.costModel.isActive,
      callback: function callback($$v) {
        _vm.$set(_vm.costModel, "isActive", $$v);
      },
      expression: "costModel.isActive"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }